/* 测试接口 */
import http from '@/utils/http-v4'
import config from '@/config/config'

// https://dev-api.idaddy.cn/swagger/?urls.primaryName=inner4%2Filisten#/
const api = {
  createOrder: `${config.apiv4Root}/inner4/ilisten/order:create`,
  payOrder: `${config.apiv4Root}/inner4/ilisten/order:pay`,
}

/**
 * 生成订单
 * @param {*} param0
 * @param {*} param0.good_id 商品id
 * @param {*} param0.good_quantity 商品数量
 * @param {*} param0.order_price 订单金额
 * @param {*} param0.coupon_id 优惠券id
 * @param {*} param0.note 备注
 */
export async function createOrder({ good_id, good_quantity, order_price, coupon_id, note } = {}) {
  return http.post(api.createOrder, {
    good_id,
    good_quantity,
    order_price,
    coupon_id,
    note,
  })
}

/**
 * 支付订单
 * @param {*} param0.order_id 订单id
 * @param {*} param0.pay_way 支付渠道
 * @param {*} param0.note 备注
 * @param {*} param0.comefrom web / sdk
 */
export async function payOrder({ order_id, pay_way = 'weixin', note, comefrom = 'web' } = {}) {
  return http.post(api.payOrder, {
    order_id,
    pay_way,
    note,
    comefrom,
  })
}
